export const MenuIcon = () => {
  return (
    <div className="relative mr-2 px-10 py-8">
      <div className="flex w-10 flex-col gap-[2px]">
        <div className="h-[1.5px] w-full bg-darkGray"></div>
        <div className="h-[1.5px] w-[85%] bg-darkGray"></div>
        <div className="h-[1.5px] w-[70%] bg-darkGray"></div>
      </div>
    </div>
  )
}
